exports.__esModule = true;
var TAG_NAMES = exports.TAG_NAMES = {
    HTML: "htmlAttributes",
    TITLE: "title",
    BASE: "base",
    META: "meta",
    LINK: "link",
    SCRIPT: "script",
    NOSCRIPT: "noscript",
    STYLE: "style"
};

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    NAME: "name",
    CHARSET: "charset",
    HTTPEQUIV: "http-equiv",
    REL: "rel",
    HREF: "href",
    PROPERTY: "property",
    SRC: "src",
    INNER_HTML: "innerHTML",
    CSS_TEXT: "cssText"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    "charset": "charSet",
    "http-equiv": "httpEquiv"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-helmet/lib/HelmetConstants.js
 ** module id = 455
 ** module chunks = 0
 **/